import * as React from 'react';

import AlertDialog from 'components/AlertDialog';
import { Container } from 'flux/utils';
import Dialog from 'components/Dialog';
import Group from 'entities/Group';
import Relationship from 'entities/Relationship';
import RelationshipActions from 'actions/RelationshipActions';
import RelationshipStore from 'stores/RelationshipStore';
import RelationshipView from 'user/components/RelationshipView';

import type { User as RelationshipViewHeaderUser } from 'user/components/RelationshipViewHeader';

type Props = {
  onRequestHide: Function;
  groupToAdmin: Group | undefined | null;
  userId: Backbone$Id;
  user?: RelationshipViewHeaderUser;
};

type State = {
  relationship: Relationship;
};

class RelationshipModal extends React.Component<Props, State> {
  static getStores() {
    return [RelationshipStore];
  }

  static calculateState(prevState: State | undefined | null, props: Props) {
    const relationship = RelationshipStore.getRelationship(props.userId);

    return {
      relationship,
    };
  }

  static prefetch = [
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
    function (props) {
      const relatedUser = RelationshipStore.getRelationship(props.userId);
      if (!relatedUser || !relatedUser.hasSubscriptions()) {
        return RelationshipActions.loadRelationship(props.userId);
      }
      return null;
    },
  ];

  static prefetchErrorModal() {
    return (
      <AlertDialog
        title="An error occurred."
        subtext={`
          We were unable to display this profile because
          you are no longer connected to the user.
        `}
        buttonText="Close"
      />
    );
  }

  static defaultProps = {
    onRequestHide: () => {},
  };

  render() {
    return (
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      <Dialog eventScreenName="RelationshipModal" {...this.props} className="RelationshipModal">
        <RelationshipView
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'Group | null | undefined' is not assignable ... Remove this comment to see the full error message
          groupToAdmin={this.props.groupToAdmin}
          user={this.props.user}
          onRequestHide={this.props.onRequestHide}
          relationship={this.state.relationship}
        />
      </Dialog>
    );
  }
}

// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
export default Container.create(RelationshipModal, { withProps: true, pure: false });
